// ============================================================================
// Module: modelPricing
//
// Currency formatting for the dashboard's agent cost figures. Nothing here
// prices anything any more: since Step 6 of docs/TOKEN_COST_ACCURACY_PLAN.md
// every $ figure is computed server-side when a usage event is ingested
// (public.model_pricing + private.resolve_model_rate, frozen on
// agent_usage_events.cost_usd) and read through src/lib/agentUsage.ts. The
// old client-side rate table / estimateCostUsd / getModelRate were removed so
// there is exactly one pricing implementation. If a rate is ever needed in the
// browser, read the `model_pricing` table (readable by any signed-in user).
//
// Figures are list-price estimates, not the team's invoice -- label them as
// such (see src/components/UsageCost.tsx).
// ============================================================================

const usdFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

// Sub-$1 figures are common here (a single day's usage) and 2 decimals
// rounds real spend down to "$0.00", which reads as broken rather than
// small. Show more precision below $1.
const usdFormatterPrecise = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 4,
})

export function formatEstimatedCost(usd: number): string {
  return Math.abs(usd) < 1 ? usdFormatterPrecise.format(usd) : usdFormatter.format(usd)
}

// Compact form for tight spaces (chart axis ticks) — mirrors the
// `notation: 'compact'` token formatters already used across these widgets.
const usdFormatterCompact = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  notation: 'compact',
  maximumFractionDigits: 1,
})

export function formatEstimatedCostCompact(usd: number): string {
  return usdFormatterCompact.format(usd)
}
